import { Node, mergeAttributes } from "@tiptap/core";

export const Grid = Node.create({
  name: "grid",
  group: "block",
  content: "block+",
  defining: true,
  selectable: true,

  parseHTML() {
    return [{ tag: "div[data-type='grid']" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "grid", class: "grid grid-cols-3 gap-4 my-12" }), 0];
  },

  addAttributes() {
    return {
      columns: {
        default: 3,
        rendered: false,
      },
    };
  },
  addCommands() {
    return {
      setGrid:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: "grid",
            content: [
              {
                type: "gridColumn",
                content: [
                  {
                    type: "gridItem",
                    content: [
                      {
                        type: "heading",
                        attrs: { level: 3 },
                        content: [{ type: "text", text: "Column 1 Title" }],
                      },
                      {
                        type: "paragraph",
                        content: [{ type: "text", text: "This is some text for column 1." }],
                      },
                    ],
                  },
                ],
              },
              {
                type: "gridColumn",
                content: [
                  {
                    type: "gridItem",
                    content: [
                      {
                        type: "heading",
                        attrs: { level: 3 },
                        content: [{ type: "text", text: "Column 2 Title" }],
                      },
                      {
                        type: "paragraph",
                        content: [{ type: "text", text: "This is some text for column 2." }],
                      },
                    ],
                  },
                ],
              },
              {
                type: "gridColumn",
                content: [
                  {
                    type: "gridItem",
                    content: [
                      {
                        type: "heading",
                        attrs: { level: 3 },
                        content: [{ type: "text", text: "Column 3 Title" }],
                      },
                      {
                        type: "paragraph",
                        content: [{ type: "text", text: "This is some text for column 3." }],
                      },
                    ],
                  },
                ],
              },
            ],
          });
        },
    };
  },
});

export const GridColumn = Node.create({
  name: "gridColumn",
  group: "block",
  content: "gridItem+",
  defining: true,

  parseHTML() {
    return [{ tag: "div[data-type='grid-column']" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "grid-column", class: "bg-gray-50 p-4 rounded-lg shadow-md grid-block" }), 0];
  },
});

export const GridItem = Node.create({
  name: "gridItem",
  group: "block",
  content: "heading paragraph+",
  defining: true,

  parseHTML() {
    return [{ tag: "div[data-type='grid-item']" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "grid-item",
        class: "space-y-4 [&>h3]:text-lg [&>h3]:font-bold [&>h3>span]:font-extrabold [&>h3]:mb-2 [&>p]:text-gray-700 [&>p]:leading-relaxed",
      }),
      0,
    ];
  },
});
